<!-- 游学列表 -->

<template>
  <div class="main" v-loading="loading">
    <back />
    <!-- 顶部搜索 -->
    <div class="s_wrapper">
      <el-input class="s_input" v-model="name" placeholder="搜索姓名" suffix-icon="el-icon-search" @change="onSearch"
        clearable></el-input>
      <el-input class="s_input" v-model="idCard" placeholder="搜索身份证号码" suffix-icon="el-icon-search" @change="onSearch"
        clearable></el-input>
      <el-input class="s_input" v-model="phone" placeholder="搜索电话号码" suffix-icon="el-icon-search" @change="onSearch"
        clearable></el-input>
      <el-button type="primary" @click="exportBillInfo">导出列表</el-button>
    </div>

    <div class="g_table">
      <el-table :data="tableData" style="width: 100%" max-height="540" @selection-change="handleSelectionChange"
        ref="tableRef" row-key="id">
        <el-table-column type="selection" min-width="55"></el-table-column>
        <el-table-column label="序号" show-overflow-tooltip width="100">
          <template slot-scope="scope">
            {{ scope.$index + 1 + (currentPage - 1) * pageSize }}
          </template>
        </el-table-column>
        <el-table-column min-width="180" show-overflow-tooltip prop="userCode" label="用户编号"></el-table-column>
        <el-table-column min-width="180" show-overflow-tooltip prop="nickName" label="用户名称"></el-table-column>
        <el-table-column min-width="180" show-overflow-tooltip prop="name" label="姓名"></el-table-column>
        <el-table-column min-width="180" show-overflow-tooltip prop="idCard" label="身份证号码"></el-table-column>
        <el-table-column min-width="180" show-overflow-tooltip prop="phone" label="电话号码">
          <template slot-scope="scope">
            <span>{{ scope.row.phone || '--' }}</span>
          </template>
        </el-table-column>
        <el-table-column min-width="180" show-overflow-tooltip prop="enrollTime" label="报名时间"></el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      id: null,
      loading: false,
      name: "",
      idCard: "",
      phone: "",
      multipleSelection: [],
      // 表格数据
      tableData: [],
      // 分页
      currentPage: 1, // 当前页码
      pageSize: 10, // 每页显示的行数
      pageSizeArr: [10, 20, 50], // 每页显示的行数(可选)
      totalItemsCount: 0, // 总记录数（需要从后端获取）

    }
  },
  created() {
    this.id = this.$route.query.id
    this.selectStudyTourUser()
  },
  methods: {
    // 导出
    exportBillInfo() {
      const studyTourUserId = this.multipleSelection.map(item => item.id);
      this.$axios
        .post(this.$api.exportStudyTourUser, {

          id: this.id,
          idCard: this.idCard,
          name: this.name,
          phone: this.phone,
          page: this.currentPage,
          pageSize: this.pageSize,
          studyTourUserId: studyTourUserId
        })
        .then(res => {
          if (res.code == 100) {
            this.$message.success("导出处理中，详情请前往下载管理查看!")
          }
        })
        .catch(err => {
          this.$message.error(err.desc)
        })
    },
    // 获取列表
    selectStudyTourUser() {
      this.loading = true
      this.$axios
        .post(this.$api.selectStudyTourUser, {
          id: this.id,
          idCard: this.idCard,
          name: this.name,
          phone: this.phone,
          page: this.currentPage,
          pageSize: this.pageSize,
        })
        .then(res => {
          if (res.code == 100) {
            this.tableData = res.result.list || []
            this.totalItemsCount = res.result.totalCount
            this.loading = false
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error(err.desc)
        })
    },

    // 选中
    handleSelectionChange(val) {
      this.multipleSelection = val
    },
    // 清空
    clearData() {
      this.tableData = []
      this.currentPage = 1
    },
    // 搜索
    onSearch() {
      this.clearData()
      this.selectStudyTourUser()
    },
    // 切换每页显示的条数
    handleSizeChange(e) {
      this.pageSize = e
      this.onSearch()
    },
    // 换页
    handleCurrentChange(e) {
      this.tableData = []
      this.currentPage = e
      this.selectStudyTourUser()
    },
  },
}
</script>

<style lang="scss" scoped>
.main {}
</style>
